import React from 'react';
import { Navigate as ReactRouterRedirect } from 'react-router-dom';
import { connect } from 'react-redux';
import prependLanguageToLink from './prepend-language-to-link';
var Redirect = function Redirect(_ref) {
  var to = _ref.to,
    push = _ref.push,
    children = _ref.children,
    siteLanguage = _ref.siteLanguage;
  return /*#__PURE__*/React.createElement(ReactRouterRedirect, {
    replace: !push,
    to: prependLanguageToLink(siteLanguage, to)
  }, children);
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var application = _ref2.application;
  return {
    siteLanguage: application.siteLanguage
  };
};
export default connect(mapStateToProps)(Redirect);